export default __webpack_public_path__ + "static/reishis-4e34246b626bfb69035190985c9730c9.webp";